<script context='module'>
  import {
    getContext,
    setContext,
    onMount,
    createEventDispatcher,
  } from 'svelte';
  import { useTrays } from './TrayRoot.svelte';

  const TRAY = Symbol('Tray');

  export const useTray = () => getContext(TRAY);
</script>

<script>
  import { writable } from 'svelte/store';
  import { browser } from '$app/environment';
  
  export let position = 'bottom';

  const active$ = writable(false);
  
  export function show() {
    $active$ = true;
  }

  export function dismiss() {
    $active$ = false;
  }

  setContext(TRAY, { dismiss });

  const addTray = useTrays();
  const dispatch = createEventDispatcher();

  const position$ = writable(position);
  $: $position$ = position;
  
  let tray;
  let entry;

  onMount(() => {
    let parent = tray.parentNode;
    tray.remove();
    entry = addTray(tray, dispatch, { position: position$ });

    return () => {
      parent.append(tray);
      parent = null;
    };
  });

  $: {
    if ($active$) {
      entry?.show();
    } else {
      entry?.dismiss();
    }
  }
</script>

{#if browser}
  <div class='container' bind:this={tray}>
    <slot {dismiss} />
  </div>
{/if}

<style>
  .container {
    position: relative;
    overflow: hidden;
  }
</style>
